import Model from './Model'
export default class ConstructionEstimateProduct extends Model {

    resource()
    {
        return 'construction-estimate-products'
    }

    get productTypes () {
        return [{
            id: 'simple',
            text: 'Norma simpla',
            hasChildren: false
        }, {
            id: 'complex',
            text: 'Norma compusa',
            hasChildren: true
        }, {
            id: 'transport',
            text: 'Transport',
            hasChildren: false
        }, {
            id: 'management',
            text: 'Organizare santier',
            hasChildren: false
        }]
    }

    get measurements() {
        return [{
            value: 'BUC',
            text: 'BUC'
        }, {
            value: 'LITRU',
            text: 'LITRU'
        }, {
            value: 'KG',
            text: 'KG'
        }, {
            value: 'ML',
            text: 'ML'
        }, {
            value: 'MC',
            text: 'MC'
        }, {
            value: 'MP',
            text: 'MP'
        }, {
            value: 'T',
            text: 'T'
        }, {
            value: 'ORA',
            text: 'ORA'
        }, {
            value: 'KM',
            text: 'KM'
        }]
    }
}
